import React, { createContext, useContext } from "react";
import fr from "./translations/fr.json";
import en from "./translations/en.json";
import de from "./translations/de.json";
import it from "./translations/it.json";
import es from "./translations/es.json";
import pt from "./translations/pt.json";

const translations = { fr, en, de, it, es, pt };

const I18nContext = createContext();

export function I18nProvider({ forcedLang = "fr", children }) {
  const lang = forcedLang || "fr";
  const t = (key) => {
    const keys = key.split(".");
    let value = translations[lang];
    for (const k of keys) {
      value = value?.[k];
    }
    return value || key;
  };

  return (
    <I18nContext.Provider value={{ lang, t }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useTranslation() {
  return useContext(I18nContext);
}